import noConnect from 'assets/illustrations/no_connect.svg'
import noData from 'assets/illustrations/no_data.svg'
import noMentions from 'assets/illustrations/no_mentions.svg'
import noMessages from 'assets/illustrations/no_messages.svg'
import noCode from 'assets/illustrations/no_code.svg'
import noCodeWhite from 'assets/illustrations/no_code_white.svg'
import noConnectWhite from 'assets/illustrations/no_connect_white.svg'
import noDataWhite from 'assets/illustrations/no_data_white.svg'
import noMentionsWhite from 'assets/illustrations/no_mentions_white.svg'
import noMessagesWhite from 'assets/illustrations/no_messages_white.svg'
import noEmailWhite from 'assets/illustrations/no_email_white.svg'
import noEmail from 'assets/illustrations/no_email.svg'
import { emptyMessages } from 'utils/message'
import { AppSchemeENUM } from 'utils/enums/appENUM'
interface EmptyProps {
    title?: string
    message: string | JSX.Element
    type?: 'no-data' | 'no-mentions' | 'no-messages' | 'no-connect' | 'no-code' | 'no-email'
    className?: string
}
export const Empty = (props: EmptyProps) => {
    const { title, message, type = 'no-mentions' } = props
    const bodyTheme = document.body.getAttribute('data-theme') as AppSchemeENUM;
    const images = {
        'no-data': noData,
        'no-mentions': noMentions,
        'no-messages': noMessages,
        'no-connect': noConnect,
        'no-code': noCode,
        'no-code-white': noCodeWhite,
        'no-data-white': noDataWhite,
        'no-mentions-white': noMentionsWhite,
        'no-messages-white': noMessagesWhite,
        'no-connect-white': noConnectWhite,
        'no-email': noEmail,
        'no-email-white': noEmailWhite,
    }
    return (
        <div className={`h-full w-full flex flex-col sm:gap-2 justify-center items-center text-gray-400 text-base ${props.className}`} id="bg-container">
            <img width={120} src={`${images[`${type}${bodyTheme === 'qualigence' ? '-white' : ''}`]}`} alt="image-not-found" />
            <div className="flex max-w-md flex-col justify-center text-center">
                <h1 className="capitalize text-lg font-bold text-gray-200">{title || emptyMessages.found}</h1>
                {message}
            </div>
        </div>
    )
}